import {
  HelpRequestInterface,
  HelpRequestModuleInterface,
  KnownServiceRequestTypes,
} from '@src/domain/types';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import { ServiceRequestPost, ServiceRequestPostRequest } from 'cmp-client-api';

const transformToApiModel = (model: HelpRequestModuleInterface): ServiceRequestPostRequest =>
  ({
    module: model.selectedModule,
    title: model.title,
    requestType: KnownServiceRequestTypes.GENERAL,
    description: model.description,
    deploysServiceModule: model.deploysServiceModule,
    inputs: model.inputs,
    deploymentContext: model.deploymentContext,
  } as ServiceRequestPostRequest);

const transformFromApiModel = (response: ServiceRequestPost): HelpRequestInterface => ({
  ...response.data,
  supportSystem: response.data.serviceNow,
});

export const HelpRequestMapper: MapperInterface<HelpRequestInterface, ServiceRequestPostRequest> = {
  transformFromApiModel,
  transformToApiModel,
} as never;
